import { Pipe, PipeTransform } from '@angular/core';
import { Images } from '../../products/interfaces/images.interface';
import { ImageModel } from '../../products/interfaces/image-model.interface';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'singleimageFilter'
})
export class SingleImageFilterPipe implements PipeTransform {
  transform(imagesList: Array<ImageModel>, imageType: string): string {
    if (imagesList && imagesList.length > 0  && imagesList[0].details && imagesList[0].details.length > 0) {
      const defaultModel = imagesList.find(x => x.isDefault);
      const productImage = defaultModel ? defaultModel.details.filter(item => item.type === imageType)[0] : null;
      if (productImage) {
        if (productImage.url.indexOf('http') === -1) {
          return (environment.cdnURL + '/' + productImage.url);
        } else {
          return productImage.url;
        }
      } else {
        return environment.uiTemplateBaseUrl + '/images/no_image.png';
      }
    } else {
      return environment.uiTemplateBaseUrl + '/images/no_image.png';
    }
  }
}
